/**
 * VpsHeroIllustration.tsx — hero-illustrasjon for /vps
 *
 * Tre isometriske plattformer koblet med prikkede linjer: server-rack,
 * terminal (rotilgang) og tre kuber i ulik størrelse (VPS-størrelser).
 * Samme stil og temafarger som de andre produktsidene; kun blå og grå aksenter.
 */

import { Box, iso } from '@/components/product/iso';
import styles from '@/components/product/illustrations.module.css';
import { Cube, Rack, Terminal } from './parts';

export default function VpsHeroIllustration({ label }: { label: string }) {
  const A = { x: -2.5, y: 0.5 }; // rack
  const B = { x: -2.5, y: -5.5 }; // terminal
  const C = { x: 3.5, y: -3.5 }; // kuber
  const size = 5;

  return (
    <svg className={styles.scene} viewBox="110 40 660 420" role="img" aria-label={label}>
      <polyline className={styles.link} points={`${iso(A.x + 2, A.y, 0)} ${iso(B.x + 2.5, B.y + size, 0)}`} />
      <polyline className={styles.link} points={`${iso(B.x + size, B.y + 3, 0)} ${iso(C.x + 0.5, C.y, 0)}`} />
      <polyline className={styles.link} points={`${iso(A.x + size, A.y + 2, 0)} ${iso(C.x, C.y + 4.5, 0)}`} />

      {/* Bakerst: terminal */}
      <Box x={B.x} y={B.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Terminal x={B.x + 0.8} y={B.y + 1.2} z={0.3} />

      {/* Høyre: kuber i tre størrelser (bakerst først) */}
      <Box x={C.x} y={C.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Cube x={C.x + 0.5} y={C.y + 0.5} z={0.3} size={1.8} tone="deep" />
      <Cube x={C.x + 2.8} y={C.y + 0.9} z={0.3} size={1.3} tone="blue" />
      <Cube x={C.x + 1.3} y={C.y + 3.1} z={0.3} size={0.9} tone="light" />

      {/* Foran: server-rack */}
      <Box x={A.x} y={A.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Rack x={A.x + 1.2} y={A.y + 1.2} z={0.3} units={4} />
    </svg>
  );
}
